import { __read } from "tslib";
import { useCallback } from 'react';
import { useUpdateUserProfileMetrics } from './useUpdateUserProfile';
import { useUserProfile } from './useUserProfile';
var incrementMetric = function (eventMetric) {
    var _a;
    var lastOccurrence = Date.now();
    return {
        count: (eventMetric === null || eventMetric === void 0 ? void 0 : eventMetric.count) !== undefined ? eventMetric.count + 1 : 1,
        firstOccurrence: (_a = eventMetric === null || eventMetric === void 0 ? void 0 : eventMetric.firstOccurrence) !== null && _a !== void 0 ? _a : lastOccurrence,
        lastOccurrence: lastOccurrence,
    };
};
export var useIncrementMetric = function () {
    var userProfile = useUserProfile();
    if (!userProfile) {
        userProfile = createEmptyUserProfile();
    }
    var _a = __read(useUpdateUserProfileMetrics(), 2), updateUserProfileMetrics = _a[0], _mutationResult = _a[1];
    return useCallback(function (name, _maxDelayInSeconds) {
        var userProfileMetrics = userProfile === null || userProfile === void 0 ? void 0 : userProfile.metrics;
        if (!userProfileMetrics) {
            // $TODO: Log metrics missing. Don't update metrics if we don't have any.
            return;
        }
        if (!name || name.length === 0) {
            // If name is empty, don't update metrics.
            return;
        }
        // Increment
        var metric = incrementMetric(userProfileMetrics[name]);
        userProfileMetrics[name] = metric;
        // Update remote storage.
        updateUserProfileMetrics(userProfileMetrics);
    }, [updateUserProfileMetrics, userProfile]);
};
var createEmptyUserProfile = function () {
    return {
        metrics: {},
        created: Date.now(),
        saved: -1,
    };
};
//# sourceMappingURL=useIncrementMetric.js.map